import LocationIcon from '../BaseComponents/LocationIcon';
import { CartSiteAddress } from '../CartProvider';
import { motion } from 'framer-motion';
import ServiceTypeTag, { ServiceType } from '../BaseComponents/SeviceType';

const CurrentLocationHeader = ({
  activeLocation,
  type,
}: {
  activeLocation: CartSiteAddress;
  type: string;
}) => {
  return (
    <div className="flex h-6 flex-col items-center justify-between sm:flex-row">
      <motion.p
        key={activeLocation?.id}
        layout
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          type: 'spring',
          mass: 1,
          stiffness: 100,
          damping: 15,
          duration: 0.4,
        }}
        className="flex items-center gap-2"
      >
        <LocationIcon />
        <span className="font-bold text-content-base-default">
          {activeLocation?.address_line_1}, {activeLocation?.city},{' '}
          {activeLocation?.state} {activeLocation?.zip}
        </span>
      </motion.p>
      <ServiceTypeTag
        type={type as ServiceType}
        className="ml-4 max-h-6 max-w-[85px]"
        labelClassName="whitespace-nowrap"
      />
    </div>
  );
};

export default CurrentLocationHeader;
